module.exports = __webpack_public_path__ + "static/img/yblogo@2x.b1406fad.png";